import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { ShoppingBag, Plus, Minus, Trash2, ChevronRight } from 'lucide-react';
import { Button } from '../components/ui/button';

const Cart = () => {
  const { items, restaurant, addItem, removeItem, clear, total } = useCart();
  const nav = useNavigate();
  const deliveryFee = items.length > 0 ? 29 : 0;
  const tax = Math.round(total * 0.05);
  const grand = total + deliveryFee + tax;

  if (items.length === 0) return (
    <div className="max-w-xl mx-auto p-10 text-center">
      <ShoppingBag className="mx-auto text-gray-300" size={60} />
      <h2 className="text-xl font-bold text-[#0B2E5C] mt-3">Your cart is empty</h2>
      <p className="text-sm text-gray-500 mt-1">Add food from your favorite restaurants</p>
      <Link to="/food-on-train"><Button className="mt-5 bg-tp-orange hover:bg-[#E07A0F] text-white font-bold">Browse Restaurants</Button></Link>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-4 py-6">
      <h1 className="text-2xl font-bold text-[#0B2E5C] mb-4">Your Cart</h1>
      <div className="bg-white rounded-xl border border-gray-100 card-shadow overflow-hidden">
        {restaurant && (
          <div className="p-4 border-b bg-[#FFF3E6] flex items-center gap-3">
            <img src={restaurant.image} alt={restaurant.name} className="w-12 h-12 rounded-lg object-cover" />
            <div>
              <div className="font-semibold text-[#0B2E5C]">{restaurant.name}</div>
              <div className="text-xs text-gray-500">{restaurant.cuisines?.join(', ')}</div>
            </div>
          </div>
        )}
        <div className="divide-y">
          {items.map(i => (
            <div key={i.id} className="p-4 flex items-center gap-3">
              <span className={`inline-block w-4 h-4 border-2 ${i.veg ? 'border-green-600' : 'border-red-600'} flex-shrink-0`}>
                <span className={`block w-1.5 h-1.5 rounded-full ${i.veg ? 'bg-green-600' : 'bg-red-600'} m-auto mt-[3px]`} />
              </span>
              <div className="flex-1">
                <div className="font-semibold text-[#0B2E5C] text-sm">{i.name}</div>
                <div className="text-xs text-gray-500">₹{i.price}</div>
              </div>
              <div className="flex items-center gap-1 border-2 border-tp-orange rounded-md">
                <button onClick={()=>removeItem(i.id)} className="px-2 py-1 text-tp-orange hover:bg-[#FFF3E6]"><Minus size={14} /></button>
                <span className="px-2 font-bold text-tp-orange text-sm">{i.qty}</span>
                <button onClick={()=>addItem(restaurant, i)} className="px-2 py-1 text-tp-orange hover:bg-[#FFF3E6]"><Plus size={14} /></button>
              </div>
              <div className="w-16 text-right font-bold text-[#0B2E5C]">₹{i.price * i.qty}</div>
            </div>
          ))}
        </div>

        <div className="p-4 border-t bg-gray-50 space-y-1 text-sm">
          <div className="flex justify-between text-gray-600"><span>Item total</span><span>₹{total}</span></div>
          <div className="flex justify-between text-gray-600"><span>Delivery fee</span><span>₹{deliveryFee}</span></div>
          <div className="flex justify-between text-gray-600"><span>Taxes & charges</span><span>₹{tax}</span></div>
          <div className="flex justify-between font-bold text-[#0B2E5C] pt-2 border-t border-dashed"><span>To Pay</span><span>₹{grand}</span></div>
        </div>
      </div>

      <div className="flex items-center justify-between mt-4 gap-3">
        <button onClick={clear} className="text-sm text-red-600 hover:underline flex items-center gap-1"><Trash2 size={14} /> Clear cart</button>
        <Button onClick={()=>nav('/checkout')} className="bg-tp-orange hover:bg-[#E07A0F] text-white font-bold h-11 px-6">
          Proceed to Checkout <ChevronRight size={16} className="ml-1" />
        </Button>
      </div>
    </div>
  );
};

export default Cart;
